import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FaSignOutAlt, FaUserShield } from 'react-icons/fa';

export default function Header() {
  const { admin, logout } = useAuth();

  return (
    <div className="sa-header">
      <h2 className="sa-header-title">🛡️ Super Admin</h2>

      <div className="sa-header-right">
        <div className="sa-admin-info">
          <FaUserShield size={18} color="#FF6B35" />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span className="sa-admin-name">{admin?.full_name}</span>
            <span className="sa-admin-role">{admin?.role}</span>
          </div>
        </div>

        <button onClick={logout} className="sa-logout-btn">
          <FaSignOutAlt size={16} />
          <span className="sa-logout-text">Çıxış</span>
        </button>
      </div>
    </div>
  );
}
